// extracted by mini-css-extract-plugin
export default {"StackingContextReset":"StackingContextReset_StackingContextReset__YzRlM","bpk-keyframe-spin":"StackingContextReset_bpk-keyframe-spin__NWI1M"};